import * as React from "react";
import "./partnerBrandPage.scss";

interface Props {
	title: string;
}

interface SubsectionProps extends Props {
	/**
	 * If true, the subsection opens its tab, so no rule separates it from anything above.
	 */
	first?: boolean;
	/**
	 * Action shown at the right end of the title row.
	 */
	aside?: React.ReactNode;
}

export const PartnerBrandSectionTitle = (props: Props) =>
	<p style={{fontWeight: 700, fontSize: "15px", color: "#112363", marginBottom: "12px", marginTop: "20px", paddingBottom: "8px", borderBottom: "1px solid #d9d9d9"}}>{props.title}</p>;

export const PartnerBrandSubsectionTitle = (props: SubsectionProps) =>
	<div className={"c-pb-subsection" + (props.first ? " is-first" : "")}>
		<p className={"c-pb-subsection_title"}>{props.title}</p>
		{props.aside && <div className={"c-pb-subsection_aside"}>{props.aside}</div>}
	</div>;
